import { NgModule } from '@angular/core';
import { LibBetaBadgeIconComponent } from './lib-beta-badge-icon.component';

@NgModule({
  declarations: [LibBetaBadgeIconComponent],
  imports: [],
  exports: [LibBetaBadgeIconComponent],
})
export class LibBetaBadgeIconModule {}
